import Container from './DefaultLayout.container';
import DefaultLayout from './DefaultLayout';

export default Container(DefaultLayout);
